import React, { useState, useEffect, useContext } from 'react';
import '../KPI.css';
import AuthContext from 'contexte/AuthContext';
import DateSelector from 'components/Filters/DateSelector/DateSelector';
import { Box } from '../KpiBox/KpiBox';
import { fetchKpiDataForDates } from 'services/kpiServices';
import { MARGIN_RELEASE_DATE } from 'utils/date';
import { SkeletonKPI } from 'components/skeleton/Skeleton';

const dateParamsOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
}

const KpiCopyInvest = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [kpiData, setKpiData] = useState({
    selectedData: {
      active_followers: 0,
      new_follows: 0,
      unfollows: 0,
      followers_pnl: 0,
      total_invested: 0,
      cash_available: 0,
      volume: 0,
      profit: 0,
      goliaths_plus_profit: 0,
      recharge_sum: 0,
      recharge_avg: 0
    },
    comparedData: {
      active_followers: 0,
      new_follows: 0,
      unfollows: 0,
      followers_pnl: 0,
      total_invested: 0,
      cash_available: 0,
      volume: 0,
      profit: 0,
      goliaths_plus_profit: 0,
      recharge_sum: 0,
      recharge_avg: 0
    }
  });
  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(MARGIN_RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await fetchKpiDataForDates(user, 'copy_invest', selectedDate.date1, selectedDate.date2);
        setKpiData(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user, selectedDate]);

  return (

    <div>
      <div className='kpi_date'>
        <DateSelector selectedDate={selectedDate} setSelectedDate={setSelectedDate} withComparaison={true} />
      </div>
      {loading ? <SkeletonKPI count={15} /> : <div className='kpi_container'>
        <Box
          title="Active followers"
          data={kpiData.selectedData.active_followers}
          link='/copy-invest/investors'
        />
        <Box
          title='New follows'
          data={kpiData.selectedData.new_follows}
          comparedData={kpiData.comparedData.new_follows}
          link='/copy-invest'
        />
        <Box
          title='Unfollows'
          data={kpiData.selectedData.unfollows}
          comparedData={kpiData.comparedData.unfollows}
          link='/copy-invest'
        />
        <Box
          title='Followers Pnl'
          data={kpiData.selectedData.followers_pnl}
          comparedData={kpiData.comparedData.followers_pnl}
          unit='€'
          link='/copy-invest'
        />
        <Box
          title='Total invested'
          data={kpiData.selectedData.total_invested}
          comparedData={kpiData.comparedData.total_invested}
          unit='€'
          link='/copy-invest/investors'
        />
        <Box
          title='Cash available'
          data={kpiData.selectedData.cash_available}
          comparedData={kpiData.comparedData.cash_available}
          unit='€'
          link='/copy-invest'
        />
        <Box
          title='Total recharge'
          data={kpiData.selectedData.recharge_sum}
          comparedData={kpiData.comparedData.recharge_sum}
          unit='€'
          link='/copy-invest/investors'
        />
        <Box
          title='Moyenne recharge'
          data={kpiData.selectedData.recharge_avg}
          comparedData={kpiData.comparedData.recharge_avg}
          unit='€'
          link='/copy-invest/investors'
        />
        <Box
          title='Volume'
          data={kpiData.selectedData.volume}
          comparedData={kpiData.comparedData.volume}
          unit='€'
          link='/copy-invest'
        />
        <Box
          title='CA Trade'
          data={kpiData.selectedData.profit}
          comparedData={kpiData.comparedData.profit}
          unit='€'
          link='/copy-invest'
        />
        <Box
          title='CA Goliaths Plus'
          data={kpiData.selectedData.goliaths_plus_profit}
          comparedData={kpiData.comparedData.goliaths_plus_profit}
          unit='€'
          link='/copy-invest'
        />
      </div>}
    </div>
  )
}


export default KpiCopyInvest